module.exports = __webpack_public_path__ + "img/chystam-party-item-border-background-green.e64bd4f.png";